<!--
  +---------------------------------------------------------------------------------------
  | @Author:    chris<jiangqingqing@frippler.com>
  | @Title:     设备增值-授权管理列表
  +---------------------------------------------------------------------------------------
-->
<template>
  <div class="ei-ciot mt-md">

    <ciot-ticket class="mb-md" @free="freeGet" @refresh="refreshData" />

    <el-card v-loading="loading" shadow="never" class="mb-md">
      <div class="mb">
        <span class="front-line">授权服务列表</span>
        <span class="filter-container ml">
          <div class="filter-item" style="width: 160px">
            <el-input v-model="query.keyword" placeholder="绑定用户 / 备注" prefix-icon="el-icon-search" clearable @change="fetchData(1)" />
          </div>
        </span>
      </div>
      <el-table ref="listTable" :data="list" tooltip-effect="dark" class="padding-small">
        <el-table-column type="index" label="#" width="50" />

        <el-table-column :show-overflow-tooltip="true" label="授权平台名称" min-width="240">
          <template slot-scope="scope">
            <span>{{ scope.row.console_title }}</span>
            <el-tooltip v-if="scope.row.god_remark" :content="scope.row.god_remark" placement="top">
              <i class="el-icon-chat-dot-round text-muted ml-xs font-md" />
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column label="服务状态" width="100">
          <template slot-scope="scope">
            <el-tag v-if="!scope.row.expired" type="success">正常</el-tag>
            <el-tag v-else type="danger">已过期</el-tag>
          </template>
        </el-table-column>
        <el-table-column min-width="135" label="服务有效期">
          <template slot-scope="scope">
            <span v-if="scope.row.expiretime">{{ scope.row.expiretime | parseTime('{y}/{m}/{d}') }}</span>
            <span v-else>长期</span>

          </template>
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" label="收费方案" min-width="160">
          <template slot-scope="scope">
            <span v-if="scope.row.expiretime && scope.row.schemeid">{{ schemeObj[scope.row.schemeid] }}</span>

          </template>
        </el-table-column>

        <el-table-column min-width="130" label="最近访问时间">
          <template slot-scope="scope">
            <span v-if="scope.row.lastlogin">{{ scope.row.lastlogin | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
            <span v-else>&nbsp;</span>
          </template>
        </el-table-column>

        <el-table-column width="120" label="绑定日期">
          <template slot-scope="scope">
            <span>{{ scope.row.bindtime | parseTime('{y}/{m}/{d}') }}</span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="绑定用户" min-width="140">
          <template slot-scope="scope">
            <div class="flex align-items-center">
              <f-user-avatar :src="scope.row.avatar" />
              <f-user-name class="ml-sm" :user="scope.row" />
            </div>
          </template>
        </el-table-column>

        <el-table-column width="100" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="handleClipboard(generateUrl(scope.row), $event)">复制链接</el-button>
          </template>
        </el-table-column>

        <template slot="append">
          <f-table-footer>
            <template slot="right">
              <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchData" />
            </template>
          </f-table-footer>
        </template>

        <div slot="empty" class="flex-center column pb-md">
          <div class="flex-center mt-hg">
            <img src="../../assets/no-data.png" alt="" class="no-data">
          </div>
        </div>
      </el-table>
    </el-card>

    <el-dialog width="900px" title="授权设置" :visible.sync="dialogShow" :modal-append-to-body="false" :close-on-click-modal="false" @close="onDialogClose">
      <el-alert type="warning" :closable="false">
        <div slot="title">温馨提示：【{{ itemRow.console_title }}】设置有效期后可选择收费方案。授权点到期后将自动调取收费方案，用户端将收到缴费通知</div>
      </el-alert>
      <div style="width: 400px; margin: 40px auto 20px">
        <el-form ref="postForm" v-loading="postLoading" label-position="left" label-width="120px" :model="formData" :rules="formRules">
          <el-form-item label="授权点名称">
            <span>{{ itemRow.console_title }}</span>
          </el-form-item>
          <el-form-item label="授权点有效期">
            <ap-date-picker v-model="formData.expiretime" :shortcuts="[90, 30, 180, 365]" style="width: 100%" clearable placeholder="请设置有效期，留空为长期" />
          </el-form-item>
          <el-form-item v-show="formData.expiretime" label="收费方案">
            <el-select v-model="formData.schemeid" placeholder="请选择收费方案" filterable clearable style="width: 100%">
              <el-option v-for="item in schemes" :key="item.schemeid" :label="item.title" :value="item.schemeid">
                <span>{{ item.title }}</span>
                <span v-if="item.scheme_unit === 'year'" class="ml"> {{ item.scheme_price | currency }} / 年 </span>
                <span v-if="item.scheme_unit === 'month'" class="ml"> {{ item.scheme_price | currency }} / 月 </span>
                <span v-if="item.scheme_unit === 'once'" class="ml"> {{ item.scheme_price | currency }} / 一次性 </span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="formData.god_remark" type="textarea" :rows="2" placeholder="添加更多备注信息" />
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer">
        <el-button @click="dialogShow = false">取 消</el-button>
        <el-button type="primary" @click="onPostFormSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <new-ciot v-if="newCiotShow" :show.sync="newCiotShow" />
    <ei-promote v-if="promoteShow" :show.sync="promoteShow" />
  </div>
</template>

<script>
import clipboard from '@/utils/clipboard'
import { ciotListApi, postCiotApi } from '@/api/ei/eiCiotApi'
import { allSchemeApi } from '@/api/ei/eiApi'

export default {
  name: 'EiCiot',

  components: {
    ApDatePicker: () => import('@/views/ap/components/ApDatePicker'),
    NewCiot: () => import('./components/NewCiot'),
    CiotTicket: () => import('./components/CiotTicket'),
    EiPromote: () => import('./components/EiPromote')
  },

  data() {
    return {
      promoteShow: false,
      free_recieved: false,
      newCiotShow: false,
      alertTitle: '',
      itemRow: {},
      postLoading: false,
      dialogShow: false,
      loading: false,
      formData: {
        expiretime: null,
        schemeid: null,
        god_remark: ''
      },
      formRules: {},
      query: {
        pindex: 1,
        psize: this.$store.state.commonStore.psize,
        keyword: '',
        expire_status: null,
        from: null,
        schemeid: null,
        bound: 1
      },
      list: [],
      schemes: [],
      status: [
        { key: 1, value: '正常' },
        { key: 2, value: '已过期' }
      ],
      multiSelection: [],
      total: 0,
    }
  },

  computed: {
    schemeObj() {
      const obj = {}
      this.schemes.map(function (e, item) {
        obj[e.schemeid] = e.title
      })
      return obj
    },

    authObj() {
      return this.$store.getters.authObj
    }
  },

  created: function () {
    const keepAlivePath = ['/rms/equip/detail']
    this.query = this.$utils.initListQuery(this.query, keepAlivePath)
    this.fetchData()
    this.fetchScheme()
  },

  beforeRouteLeave(to, from, next) {
    this.$utils.saveListQuery(this.query)
    next()
  },

  methods: {
    fetchData(page) {
      if (page) this.query.pindex = page
      this.loading = true
      ciotListApi(this.query).then(res => {
        this.loading = false
        if (res.errno === 0) {
          this.list = res.data.list
          this.total = res.data.total
        } else {
          this.$message.error(res.message)
        }
      })
    },

    fetchScheme() {
      allSchemeApi().then(res => {
        if (res.errno === 0) {
          this.schemes = res.data.list
        } else {
          this.$message.error(res.message)
        }
      })
    },

    chooseScheme(command) {
      const temp = {
        cid: command.row.cid,
        schemeid: command.schemeid
      }
      postCiotApi(temp).then(res => {
        if (!res.errno) {
          this.$message.success(command.row.console_title + ' 收费方案设置成功')
          this.fetchData()
        } else {
          this.$message.error(res.message)
        }
      })
    },

    changeExpire(row) {
      this.itemRow = Object.assign({}, row)
      this.formData.expiretime = this.itemRow.expiretime ? this.itemRow.expiretime : null
      this.formData.schemeid = this.itemRow.schemeid ? this.itemRow.schemeid : null
      this.dialogShow = true
    },

    generateUrl(row) {
      return `${row.web_url}`
    },

    handleClipboard(text, event) {
      clipboard(text, event)
    },

    onDialogClose() {
      this.$nextTick(() => {
        this.$refs['postForm'].clearValidate()
      })
    },

    onPostFormSubmit() {
      this.$refs['postForm'].validate(valid => {
        if (valid) {
          const temp = {
            cid: this.itemRow.cid,
            schemeid: this.formData.schemeid,
            expiretime: this.formData.expiretime ? this.formData.expiretime : 0,
            god_remark: this.formData.god_remark
          }
          postCiotApi(temp).then(res => {
            if (!res.errno) {
              this.dialogShow = false
              this.$message.success(this.itemRow.console_title + ' 有效期设置成功')
              this.fetchData()
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          return false
        }
      })
    },

    freeGet(free_recieved) {
      this.free_recieved = free_recieved
    },

    refreshData() {
      this.fetchData()
      this.fetchScheme()
    },

    toDoc() {
      window.open('https://doc.frippler.com/aiot/ei/ciot.html')
    },

  }
}
</script>

